import api from "./index";

export interface TestListParams {
  title?: string;
  companyId?: string;
  ownerId?: string;
  enabled?: boolean;
  locale?: string;
  createdAtMin?: Date;
  createdAtMax?: Date;
  updatedAtMin?: Date;
  updatedAtMax?: Date;
  limit?: number;
  offset?: number;
  sort?: "id" | "title" | "createdAt" | "updatedAt";
  order?: "ASC" | "DESC";
  options?: any;
}

export default (params: TestListParams, options?: any) => {
  return api.TestApi.list(
    params.title,
    params.companyId,
    params.ownerId,
    params.enabled,
    params.locale,
    params.createdAtMin,
    params.createdAtMax,
    params.updatedAtMin,
    params.updatedAtMax,
    params.limit,
    params.offset,
    params.sort,
    params.order,
    params.options
  );
};
